// extracted by mini-css-extract-plugin
export default {"nav":"pokemons_nav__TvWeJ","listItem":"pokemons_listItem__4BfjC","listItemIcon":"pokemons_listItemIcon__WIwfr","listItemText":"pokemons_listItemText__cjb8T"};